import i18n from 'services/base/i18n';

export default {
  portOption:  () => i18n.pgettext('Components|List History|Filter History|Protocol Entry', 'Custom port number'),
  rangeOption: () => i18n.pgettext('Components|List History|Filter History|Protocol Entry', 'Custom port range'),
  anyProtocol: () => i18n.pgettext('Components|List History|Filter History|Protocol Entry', 'Any'),
};
